/** Display helpers for SSH public keys. */

export const normalizePublicKey = (value: string) => value.trim().replace(/\s+/g, " ");

const hashPublicKeyBody = async (publicKey: string): Promise<Uint8Array> => {
  const parts = normalizePublicKey(publicKey).split(" ");
  if (parts.length < 2) {
    return new Uint8Array();
  }
  const keyBody = parts[1];
  const padded = keyBody + "=".repeat((4 - (keyBody.length % 4)) % 4);
  const binary = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0));

  if (typeof crypto !== "undefined" && crypto.subtle) {
    return new Uint8Array(await crypto.subtle.digest("SHA-256", binary));
  }

  const { createHash } = await import("crypto");
  return createHash("sha256").update(Buffer.from(binary)).digest();
};

/** Truncated colon-separated fingerprint for display (matches server format). */
export const computeSshKeyFingerprint = async (publicKey: string): Promise<string> => {
  const hash = await hashPublicKeyBody(publicKey);
  if (hash.length === 0) return "";
  const hex = Array.from(hash)
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join(":");
  return `${hex.split(":").slice(0, 4).join(":")}:...`;
};
